import { AISummaryStatus } from 'api/dto/AISummary.dto';

import {
  mapPerspectiveKeyPointDtoToModel,
  PerspectiveKeyPointDto,
  PerspectiveKeyPointModel,
} from './PerspectiveKeyPoint.dto';

export type PerspectiveSummaryDto = {
  id: string;
  keyPoints: PerspectiveKeyPointDto[];
  perspective: string;
  status: AISummaryStatus;
  topic: string;
};

export type PerspectiveSummaryModel = {
  id: string;
  keyPoints: PerspectiveKeyPointModel[];
  perspective: string;
  status: AISummaryStatus;
  topic: string;
};

export const mapPerspectiveSummaryDtoToModel = (
  dto: PerspectiveSummaryDto
): PerspectiveSummaryModel => ({
  id: dto.id,
  keyPoints: dto.keyPoints.map(mapPerspectiveKeyPointDtoToModel),
  perspective: dto.perspective,
  status: dto.status,
  topic: dto.topic,
});
